/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
// material
import { TextField } from '@insticator/insticator-ui'
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'
import EmojiPreview from 'material/emojipreview/emojipreview';
// styles
import injectSheet from 'react-jss'
import styles from './headline_styles'


/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: GENERAL SECTION : HEADLINE ~~~~~~~~~~ ========== */
const Headline = injectSheet(styles)((props) => {

  const { headline, onChange } = props

  return (
    <Space gap={48} justifyContent={'space-between'} klass={`headline ${props.classes.headline}`} > 
      <SectionGroupV2 
        indented={true} 
        title={'Headline'} 
        rowGap={32} 
        direction={'column'}
      >
        <TextField 
        type={`text`} 
        name={`headline`} 
        icon={<ComposeIcon />}
        value={headline} 
        handleChange={e => onChange({'headline': e.target.value})}
        placeholder={``} 
        required
        valid={!!headline}
      />
    </SectionGroupV2>
    <PreviewConfig>
      <EmojiPreview showPlaceholder headline={headline || ''} />
    </PreviewConfig>
  </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Headline;